var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "rexer_event",
      class: _vm.renderClass(_vm.event),
      attrs: { id: "rexer_event-" + _vm.event.id }
    },
    [
      _c("section", { staticClass: "rexer_event__header" }, [
        _c("div", { staticClass: "rexer_event__time" }, [
          _c("span", { staticClass: "rexer_event__time-date" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm._f("moment")(_vm.event.date_time, "DD.MM.YY, HH.mm")
                ) +
                " UHR\n      "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "rexer_event__body" }, [
        _c("h3", { staticClass: "rexer_event__body-title" }, [
          _vm._v("\n      " + _vm._s(_vm.event.title.rendered) + "\n    ")
        ]),
        _vm._v(" "),
        _vm.event.excerpt.rendered
          ? _c("div", {
              staticClass: "rexer_event__body-desc",
              domProps: { innerHTML: _vm._s(_vm.event.excerpt.rendered) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "rexer_event__contact" },
          [
            _c("h6", { staticClass: "has-text-white" }, [
              _vm._v("Informationen & Reservationen:")
            ]),
            _vm._v(" "),
            _vm.event.email !== ""
              ? _c("EventContact", {
                  attrs: { text: _vm.event.email, type: "email" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.event.website !== ""
              ? _c("EventContact", {
                  attrs: { text: _vm.event.website, type: "www" }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("p", { staticClass: "rexer_event__body-location" }, [
          _vm._v("\n      " + _vm._s(_vm.event.location) + "\n    ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rexer_event__brand" }, [
          _c(
            "a",
            {
              attrs: {
                href: _vm.event.brand_url !== "" ? _vm.event.brand_url : "#",
                title: _vm.event.title.rendered,
                target: "_blank"
              }
            },
            [
              _c("img", {
                attrs: {
                  src: _vm.event.branding.guid,
                  alt: _vm.event.branding.post_title
                }
              })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "rexer_event__footer" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }